import { render, staticRenderFns } from "./sensitiveWord-add.vue?vue&type=template&id=7d45ffb4&scoped=true"
import script from "./sensitiveWord-add.vue?vue&type=script&lang=js"
export * from "./sensitiveWord-add.vue?vue&type=script&lang=js"
import style0 from "./sensitiveWord-add.vue?vue&type=style&index=0&id=7d45ffb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d45ffb4",
  null
  
)

export default component.exports